import BgColorConfig from "./BgColorConfig/BgColorConfig";
import BgMusicConfig from "./BgMusicConfig/BgMusicConfig";
import CoverConfig from "./CoverConfig/CoverConfig";
import BgBlurConfig from "./BgBlurConfig/index";
import ConfigStore from "@/stores/mixedConfig/index";
import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader
} from "@/pages/VideoClips/MixCutDetail/UIComponents/VideoConfigCard/VideoConfigCard";
import OpenDrawer from "@/pages/VideoClips/MixCutDetail/VideoConfig/OpenDrawer/OpenDrawer";
import { useState } from "react";
import SmallSearch
  from "@/pages/VideoClips/MixCutDetail/BgConfig/BgMusicConfig/BgMusicTabs/BgMusicContainer/SmallSearch/SmallSearch";
import ChoseDetailPopover from "@/pages/VideoClips/MixCutDetail/ChoseDetailPopover/ChoseDetailPopover";
import BgMusicTabs from "@/pages/VideoClips/MixCutDetail/BgConfig/BgMusicConfig/BgMusicTabs/BgMusicTabs";
import CommonUpload from "@/components/business/CommonUpload";
import {toJS} from "mobx";
import allowTypeStore from "@/stores/allowTypeStore";
import '@/pages/VideoClips/MixCutDetail/BgConfig/BgConfig.less'
import {Select} from "@arco-design/web-react";
import React from "react";
import { observer } from "mobx-react";
const mapType = {
  1: "背景图片",
  2: "背景颜色",
  3: "背景虚化"
}
const BgConfig = () => {
  const [checked, setChecked] = useState(1)
  return (
    <>
      <BgMusicConfig />
      <VideoConfigCard style={{ marginTop: 20 }}>
        <VideoConfigCardHeader
          headerLeft={
            <div className={"flex--start--center"}>
              { mapType[checked] }
              {
                checked === 2 && <div
                  className="header-color-block"
                  style={{background: ConfigStore.global_settings.background.color}}>
                </div>
              }
            </div>
          }
          headerRight={<>
            <div className="flex--between--center">
              <Select
                size="small"
                className={"bg-search-filed-select"}
                style={{
                  height: 26,
                  width: "119px",
                }}
                value={checked}
                options={[
                  {
                    label: "背景图片",
                    value: 1,
                  },
                  {
                    label: "背景颜色",
                    value: 2,
                  },
                  {
                    label: "背景虚化",
                    value: 3,
                  }
                ]}
                placeholder="请选择"
                onChange={(e) => {
                  setChecked(e)
                }}
              />
            </div>
          </>
          }></VideoConfigCardHeader>
        <VideoConfigCardContainer style={{ padding: 0 }}>
          <CoverConfig style={{ display: checked === 1 ? 'block' : 'none'}} />
          <BgColorConfig style={{ display: checked === 2 ? 'block' : 'none'}} />
          <BgBlurConfig style={{ display: checked === 3 ? 'flex' : 'none'}}  />
        </VideoConfigCardContainer>
      </VideoConfigCard>
    </>
  );
};

export default observer(BgConfig);
